import {
  Button,
  Dialog,
  TextInput,
  TextInputProps,
  createForm,
  Text,
  Flex,
} from '@applyboard/crystal-ui'
import { ComponentType } from 'react'
import { emailValidate } from '../../utils/fieldValidations'

type UpdateEmailDialogProps = {
  open: boolean
  loading: boolean
  currentEmail: string
  onOpenChange: (open: boolean) => void
  onSubmit: (email: string) => void
}

const { Form: UpdateEmailForm, Field: UpdateEmailField } = createForm<{ email: string }>()

export function UpdateEmailDialog(props: UpdateEmailDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <Dialog.Heading>
        <Flex direction="column" gap={0}>
          <Text variant="labelS">STEP 1/3</Text>
          <Text variant="titleM">Provide your new email address.</Text>
        </Flex>
      </Dialog.Heading>
      <Dialog.Content>
        <UpdateEmailForm
          defaultValues={{ email: props.currentEmail }}
          onSubmit={data => props.onSubmit(data.email)}
          id="update-email-form"
        >
          <UpdateEmailField
            as={TextInput as ComponentType<TextInputProps>}
            label="New email"
            name="email"
            validate={email => {
              if (!emailValidate(email)) {
                return 'Please enter a valid email address.'
              }
              if (email === props.currentEmail) {
                return 'Email must be different than current email'
              }
              return true
            }}
          />
        </UpdateEmailForm>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Cancel</Dialog.CloseButton>
        <Button
          intent="primary"
          width="fill"
          type="submit"
          form="update-email-form"
          loading={props.loading}
        >
          Continue
        </Button>
      </Dialog.Actions>
    </Dialog>
  )
}
